import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TagaPlatformOverview from "./components/TagaPlatformOverview";
import { Download, Settings } from "@carbon/icons-react";
import ToolsShowcase from "./components/ToolsShowcase";
import TagaStudio from "./assets/TagaStudio.png";
import Group from "./assets/group.png";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header />
      <section className="relative pt-32 sm:pt-40 pb-16 sm:pb-32 overflow-hidden min-h-[750px] sm:min-h-[90vh] lg:h-[100vh] lg:min-h-[900px]">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 via-teal-500 via-blue-500 via-indigo-500 to-purple-600 top-[80px] sm:top-[110px] left-4 sm:left-6 lg:left-10 right-4 sm:right-6 lg:right-10 bottom-4 sm:bottom-6 lg:bottom-10 rounded-xl sm:rounded-2xl flex flex-col items-center justify-end p-3 sm:p-4 lg:p-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 sm:p-4 max-w-4xl mx-auto border border-white/20 w-full">
            <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
              {/* Editor Header */}
              <div className="flex items-center justify-between px-2 sm:px-4 py-2 bg-gray-50 border-b border-gray-100">
                <div className="flex space-x-1 sm:space-x-2">
                  <div className="w-2 h-2 sm:w-3 sm:h-3 bg-red-500 rounded-full"></div>
                  <div className="w-2 h-2 sm:w-3 sm:h-3 bg-yellow-500 rounded-full"></div>
                  <div className="w-2 h-2 sm:w-3 sm:h-3 bg-green-500 rounded-full"></div>
                </div>
              </div>

              <div className="p-3  min-h-[150px] sm:min-h-[300px] flex items-center justify-center">
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={TagaStudio}
                    alt="TagaStudio"
                    className="w-full h-full object-cover mix-blend-multiply"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 text-white leading-tight">
            Nền tảng làm việc trọn gói
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto px-4">
            Quản lý thông tin, quy trình làm việc và con người, tất cả ở cùng
            một nơi.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 sm:mb-16 px-4">
            <button
              className="bg-black text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-gray-800 transition-colors flex items-center w-full sm:w-auto justify-center"
              onClick={() => {
                window.open("https://taganow.vn/download", "_blank");
              }}
            >
              <Download
                size={20}
                className="mr-2"
              />
              Tải xuống
            </button>
            <button
              className="text-white/80 hover:text-white transition-colors underline bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-3 sm:py-4 rounded-lg w-full sm:w-auto"
              onClick={() => {
                const form = document.getElementById("newsletter-form");
                if (form) {
                  form.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              Liên hệ
            </button>
          </div>
        </div>
      </section>

      <TagaPlatformOverview />

      {/* Tools Showcase Section */}
      <ToolsShowcase />

      {/* Trusted by section */}
      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-lg sm:text-xl lg:text-2xl uppercase text-gray-600 mb-8 sm:mb-12">
            Tin dùng bởi
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-9 gap-4 sm:gap-6 lg:gap-8 items-center opacity-60">
            {[
              "Johnson & Johnson",
              "Stripe",
              "Samsung",
              "Instacart",
              "Perplexity",
              "Ramp",
              "Shopify",
              "US Foods",
              "Nadilabs",
            ].map((company, idx) => (
              <div
                key={idx}
                className="text-center text-xs sm:text-sm font-medium text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900 hover:border-gray-200 rounded-lg p-2 cursor-pointer"
              >
                {company}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="relative py-20 sm:py-28 overflow-hidden">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50/80 via-blue-50/40 to-purple-50/60"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-400/10 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16 sm:mb-20">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 bg-gradient-to-r from-gray-900 via-blue-800 to-purple-800 bg-clip-text text-transparent">
              Giải pháp toàn diện cho doanh nghiệp
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Khám phá những tính năng mạnh mẽ giúp tối ưu hóa quy trình làm
              việc và nâng cao hiệu suất của bạn
            </p>
          </div>

          <div className="space-y-24 sm:space-y-32">
            {/* Feature 1 */}
            <div className="group">
              <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div className="space-y-8 text-center lg:text-left">
                  <div className="space-y-6">
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                      <Settings size={16} />
                      Quản lý nhóm
                    </div>
                    <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
                      Quản lý nhóm/
                      <span className="block bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                        tổ chức linh hoạt
                      </span>
                    </h3>
                    <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
                      Taga cung cấp các công cụ mạnh mẽ để bạn quản lý nhóm và
                      tổ chức của bạn một cách linh hoạt, hiệu quả và minh bạch.
                    </p>
                  </div>

                  {/* Feature highlights */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    {[
                      {
                        icon: "👥",
                        title: "Quản lý thành viên",
                        desc: "Phân quyền và vai trò chi tiết",
                      },
                      {
                        icon: "📊",
                        title: "Báo cáo hiệu suất",
                        desc: "Theo dõi tiến độ real-time",
                      },
                      {
                        icon: "🔄",
                        title: "Quy trình tự động",
                        desc: "Workflow thông minh",
                      },
                      {
                        icon: "💬",
                        title: "Giao tiếp nhóm",
                        desc: "Chat và video call tích hợp",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="flex items-start gap-3 p-4 bg-white/70 backdrop-blur-sm rounded-xl border border-gray-200/50 hover:border-blue-300/50 transition-all duration-300 hover:shadow-md"
                      >
                        <span className="text-2xl">{item.icon}</span>
                        <div>
                          <h4 className="font-semibold text-gray-900 text-sm">
                            {item.title}
                          </h4>
                          <p className="text-xs text-gray-600 mt-1">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="relative transition-transform">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 to-purple-600/20 rounded-xl blur-2xl transform rotate-6"></div>
                  <div className="relative bg-white/90 backdrop-blur-sm rounded-xl p-6 border border-gray-200/50  overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 to-purple-500"></div>
                    <div className="aspect-video flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl">
                      <img
                        src={Group}
                        alt="Quản lý nhóm"
                        className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                      />
                    </div>
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-white/80 backdrop-blur-sm rounded-lg p-3 border border-gray-200/50">
                        <div className="flex items-center gap-2 text-sm">
                          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                          <span className="font-medium text-gray-900">
                            15 thành viên đang hoạt động
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="group">
              <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <div className="lg:order-2 space-y-8 text-center lg:text-left">
                  <div className="space-y-6">
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                      Bảo mật cao
                    </div>
                    <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
                      Quản lý công việc và
                      <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                        dữ liệu bảo mật
                      </span>
                    </h3>
                    <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
                      Taga đảm bảo an toàn tuyệt đối cho dữ liệu và quy trình
                      làm việc của bạn với các tiêu chuẩn bảo mật hàng đầu thế
                      giới.
                    </p>
                  </div>

                  {/* Security features */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    {[
                      {
                        icon: "🔒",
                        title: "Mã hóa E2E",
                        desc: "Bảo mật end-to-end toàn diện",
                      },
                      {
                        icon: "🛡️",
                        title: "Firewall AI",
                        desc: "Phát hiện mối đe dọa thông minh",
                      },
                      {
                        icon: "🔑",
                        title: "2FA Security",
                        desc: "Xác thực hai yếu tố",
                      },
                      {
                        icon: "📋",
                        title: "Audit Log",
                        desc: "Nhật ký hoạt động chi tiết",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="flex items-start gap-3 p-4 bg-white/70 backdrop-blur-sm rounded-xl border border-gray-200/50 hover:border-emerald-300/50 transition-all duration-300 hover:shadow-md"
                      >
                        <span className="text-2xl">{item.icon}</span>
                        <div>
                          <h4 className="font-semibold text-gray-900 text-sm">
                            {item.title}
                          </h4>
                          <p className="text-xs text-gray-600 mt-1">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="lg:order-1 relative transition-transform">
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/20 to-teal-600/20 rounded-xl blur-2xl transform -rotate-6"></div>
                  <div className="relative bg-white/90 backdrop-blur-sm rounded-xl p-6 border border-gray-200/50 overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-500 to-teal-500"></div>
                    <div className="aspect-video flex items-center justify-center bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl">
                      <img
                        src={Group}
                        alt="Bảo mật dữ liệu"
                        className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                      />
                    </div>
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-white/80 backdrop-blur-sm rounded-lg p-3 border border-gray-200/50">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2 text-sm">
                            <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                            <span className="font-medium text-gray-900">
                              Bảo mật cấp độ doanh nghiệp
                            </span>
                          </div>
                          <div className="text-xs bg-emerald-100 text-emerald-700 px-2 py-1 rounded-full font-medium">
                            99.9%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA section */}

      <Footer />
    </div>
  );
};

export default LandingPage;
